import { RootState } from "../reducers"
import { createSelector } from "@reduxjs/toolkit"

export const selectUser = (state: RootState) => state.user
export const selectUserPermissions = createSelector(
  selectUser,
  (user) => user.entry.permissions ?? [],
)
export const selectUserGroups = createSelector(
  selectUser,
  (user) => user.entry.groups ?? [],
)
export const selectDefaultUserBuilding = (state: RootState) =>
  state.user.entry.building

export const selectDefaultUserFloor = (state: RootState) =>
  state.user.entry.floor
